module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/profile/profile.component.scss
// module id = ./src/app/components/profile/profile.component.scss
// module chunks = main